import { useCallback, useRef } from "react";
import { RequestHelper } from "../../../utils/requestHelper";
import { _ROUTES } from "../../../utils/_routes_constants";
import { _ACTIONS, _HTTP, _MESSAGES } from "../../../utils/constants";
import { createToast } from "../../../utils/toast";
import { isNaN } from "lodash";

/**
 *
 * @param {string} params.site - The site identifier.
 * @param {string} params.fiscalYear - The fiscal year.
 * @param {string} params.version - The version.
 * @param {Object} gridRef - Reference to the grid component.
 *
 * @returns {Function} Callback function to handle cell value changes.
 *
 */
export function useSalesOnCellValueChanged(params, gridRef) {
  const requestHelper = new RequestHelper();
  const pendingUpdatesRef = useRef(0);

  return useCallback(
    async (agParams) => {
      const { colDef, data, newValue } = agParams;
      const { site, fiscalYear, version } = params;
      const { group, rowName } = data;
      const field = colDef.field;

      if (!site || !fiscalYear || !version || !newValue || isNaN(newValue)) {
        createToast(
          "warning",
          "No site, value, fiscal or year available. Please check if you missed something.",
        );
        return;
      }

      let payload = {
        version,
        fiscalYear,
        fiscalMonth: parseInt(field),
        site,
        activity: group,
        type: rowName,
        value: newValue,
      };

      pendingUpdatesRef.current++;

      requestHelper
        .doRequest(_ACTIONS.POST, _ROUTES.SAVE_DEPRECIATION, payload)
        .then((response) => {
          if (response.status === _HTTP.ok) {
            if (gridRef.current?.api) {
              const rowNode = gridRef.current.api.getRowNode(data.id);
              if (rowNode) {
                gridRef.current.api.applyTransaction({
                  update: [{ ...data, [field]: newValue }],
                });
              }
            }
          } else {
            createToast("error", "Error saving data");
          }
        })
        .finally(() => {
          pendingUpdatesRef.current--;

          // If is the last update, create a success toast.
          if (pendingUpdatesRef.current === 0) {
            createToast("success", _MESSAGES.data_sent);
          }
        });
    },
    [params],
  );
}
